// assets/cart-sdl-preview.js
(function () {
  /* ========= 小工具 ========= */
  const LS_KEY = "sdlPreviewCache:v2"; // 升版改尾碼即清快取
  const cache = (() => {
    try { return JSON.parse(localStorage.getItem(LS_KEY) || "{}"); }
    catch { return {}; }
  })();
  function saveCache() {
    try { localStorage.setItem(LS_KEY, JSON.stringify(cache)); } catch {}
  }

  // "Equal Lite" -> ["equal_lite","equal-lite","equal lite"]
  function styleVariants(raw) {
    const base = String(raw || "")
      .toLowerCase()
      .replace(/&/g, "and")
      .replace(/[^a-z0-9\s-]/g, " ")
      .replace(/\s+/g, " ")
      .trim();
    const under = base.replace(/\s+/g, "_");
    const dash  = base.replace(/\s+/g, "-");
    return Array.from(new Set([under, dash, base]));
  }
  // "2 W x 2 H" / "2Wx2H" / "2W2H" -> "2w2h"
  function normalizeGridPattern(s) {
    if (!s) return null;
    let t = String(s).toLowerCase();
    t = t.replace(/\s*x\s*/g, "x").replace(/\s+/g, "").replace(/[^0-9whx]/g, "");
    t = t.replace(/(\d+)wx(\d+)h/, "$1w$2h").replace(/(\d+)w(\d+)h/, "$1w$2h");
    return t || null;
  }
  // "2w2h" -> "2x2"
  function gridTo2x2(gridSlug) {
    const m = (gridSlug || "").match(/(\d+)w(\d+)h/);
    return m ? `${m[1]}x${m[2]}` : null;
  }

  /* ========= 新增：SDL 解析 + 警示圖 ========= */

  // 解析 SDL 數量：支援「15 x SDL / SDL x15 / Grid: 10 x SDL / Grid: SDL = 12」
  function parseSdlCount(raw){
    let s = String(raw||'').toLowerCase().replace(/×/g,'x').replace(/：/g,':').replace(/\s+/g,' ').trim();
    let m = s.match(/(^|[^a-z0-9])(\d{1,3})\s*x\s*sdl([^a-z0-9]|$)/); if (m) return parseInt(m[2],10);
    m = s.match(/sdl\s*x?\s*([0-9]{1,3})([^a-z0-9]|$)/);                 if (m) return parseInt(m[1],10);
    m = s.match(/grid\s*:\s*([0-9]{1,3})\s*x\s*sdl/);                    if (m) return parseInt(m[1],10);
    m = s.match(/grid\s*:\s*sdl\s*[:=]?\s*([0-9]{1,3})/);                if (m) return parseInt(m[1],10);
    return null;
  }

  // 在盒內顯示 need_drawing.png（使用你現有的圖）
  function showNeedDrawing(box){
    box.innerHTML = '';
    const img = new Image();
    img.src = 'https://cdn.shopify.com/s/files/1/0963/0577/4914/files/need_drawing.png?v=1761794170';
    img.alt = 'Need drawing';
    img.style.width = '70%';
    img.style.height = 'auto';
    img.style.objectFit = 'contain';
    box.appendChild(img);
  }

  // 依照「你現在的命名」優先組出最可能的檔名（速度關鍵）
  function primaryName(gridSlug, styleRaw) {
    const g2x2 = gridTo2x2(gridSlug) || gridSlug;  // 先偏好 2x2
    const sUnder = styleVariants(styleRaw)[0];     // 先偏好底線
    // 先試 jpg（你的圖就是 jpg）
    return `${g2x2}_${sUnder}.jpg`;
  }

  // 後備候選（若 primary miss 才會試，數量不多）
  function fallbackNames(gridSlug, styleRaw) {
    const g2x2 = gridTo2x2(gridSlug);
    const styles = styleVariants(styleRaw); // [under, dash, space]
    const grids  = [g2x2, gridSlug].filter(Boolean); // 2x2, 2w2h
    const names = [];
    for (const g of grids) {
      for (const st of styles) {
        names.push(`${g}_${st}`, `${g}-${st}`, `${g} ${st}`);
      }
    }
    const exts = ["jpg","png","webp","jpeg"];
    const out  = [];
    for (const n of names) for (const e of exts) out.push(`${n}.${e}`);
    // 把 primary 從列表去掉，避免重複請求
    const p = primaryName(gridSlug, styleRaw);
    return out.filter(n => n !== p);
  }

  // 加寬度參數，小圖更快（用容器寬 * 2，Retina 更清晰）
  function withWidth(url, box) {
    let w = Math.max(80, Math.min(600, Math.round((box.clientWidth || 110) * 2)));
    // 已有 query 就追加 &width=
    return url + (url.includes("?") ? `&width=${w}` : `?width=${w}`);
  }


  // 直接載入 Liquid 產生的 Shopify Files 版本化 URL（包含目前的 ?v= 版本碼）
  function loadDirectUrl(box, rawUrl) {
    const url = withWidth(String(rawUrl || ""), box);
    return new Promise((resolve, reject) => {
      const img = new Image();
      try { img.fetchPriority = "high"; } catch {}
      try { img.decoding = "sync"; } catch {}
      try { img.loading = "eager"; } catch {}
      img.onload = () => resolve({ img, url });
      img.onerror = () => reject(new Error("direct URL failed"));
      img.src = url;
    });
  }

  // 競速載入：同時試 /files/ 與 /cdn/shop/files/，誰先載到用誰
  function raceLoad(box, filename) {
    const bases = ["/files/", "/cdn/shop/files/"];
    const urls  = bases.map(b => withWidth(b + encodeURIComponent(filename), box));

    return new Promise((resolve, reject) => {
      let settled = false, pending = urls.length;

      urls.forEach(url => {
        const img = new Image();
        img.fetchPriority = "high";
        img.decoding = "sync";
        img.loading = "eager";

        img.onload = () => {
          if (settled) return;
          settled = true;
          resolve({ img, url });
        };
        img.onerror = () => {
          if (--pending === 0 && !settled) reject(new Error("all failed"));
        };
        img.src = url;
      });
    });
  }

  async function resolveUrlFast(box, gridSlug, styleRaw) {
    const key = `${gridSlug}__${styleRaw}`.toLowerCase().trim();
    const liquidUrl = box.getAttribute("data-primary-url") || "";
    const liquidFile = box.getAttribute("data-primary-file") || primaryName(gridSlug, styleRaw);

    // 1) 永遠先試 Shopify Liquid 產生的版本化 URL；不讓舊 localStorage 或舊 CDN 蓋過新圖。
    if (liquidUrl) {
      try {
        const { img, url } = await loadDirectUrl(box, liquidUrl);
        cache[key] = liquidFile; saveCache();
        return { img, file: liquidFile, url, source: "liquid-versioned" };
      } catch { /* 若檔案不存在，再走舊命名備援 */ }
    }

    // 2) 試標準檔名。
    const primary = primaryName(gridSlug, styleRaw);
    try {
      const { img, url } = await raceLoad(box, primary);
      cache[key] = primary; saveCache();
      return { img, file: primary, url, source: "primary-fallback" };
    } catch {}

    // 3) 最後才讀舊快取，而且不得重複標準檔名。
    if (cache[key] && cache[key] !== primary) {
      try {
        const { img, url } = await raceLoad(box, cache[key]);
        return { img, file: cache[key], url, source: "legacy-cache" };
      } catch {}
    }

    // 4) 少量不同命名／副檔名備援。
    const fallbacks = fallbackNames(gridSlug, styleRaw);
    for (const name of fallbacks) {
      try {
        const { img, url } = await raceLoad(box, name);
        cache[key] = name; saveCache();
        return { img, file: name, url, source: "filename-fallback" };
      } catch {}
    }
    throw new Error("no match");
  }

  function mountOne(box) {
    const gridRaw  = box.getAttribute("data-grid")  || "";
    const styleRaw = box.getAttribute("data-style") || "";

    // 讀取 data-sdl，限制 2~18（含）
    const sdlRaw  = box.getAttribute("data-sdl") || "";
    const sdlCnt  = parseSdlCount(sdlRaw);
    if (sdlCnt !== null && (sdlCnt < 2 || sdlCnt > 18)) {
      // 超出範圍 → 直接顯示警示圖
      showNeedDrawing(box);
      return;
    }

    const gridSlug = normalizeGridPattern(gridRaw);
    if (!gridSlug || !styleRaw) {
      box.textContent = "No preview";
      box.style.fontSize = "11px"; box.style.opacity = "0.7";
      return;
    }

    // 載入中的骨架（不等圖片下載完成就先畫，體感更快）
    if (!box.__skeleton) {
      box.__skeleton = true;
      box.innerHTML = '<div style="width:60%;height:8px;background:#eee;border-radius:4px;animation:pulse 1s infinite"></div>';
      if (!document.getElementById("sdl-pulse-style")) {
        const st = document.createElement("style");
        st.id = "sdl-pulse-style";
        st.textContent = "@keyframes pulse{0%{opacity:.35}50%{opacity:1}100%{opacity:.35}}";
        document.head.appendChild(st);
      }
    }

    resolveUrlFast(box, gridSlug, styleRaw)
      .then(({ img, file, url, source }) => {
        box.innerHTML = "";
        // 個別尺寸覆蓋（若 snippet 有 data-sdl-w/h）
        const w = box.getAttribute("data-sdl-w");
        const h = box.getAttribute("data-sdl-h");
        if (w) box.style.width = w;
        if (h) box.style.maxHeight = h;

        img.style.width = "70%";
        img.style.height = "auto";
        img.style.maxHeight = (h || "var(--sdl-preview-maxh)");
        img.style.objectFit = "contain";
        box.appendChild(img);
        try {
          box.setAttribute("data-file", file || "");
          box.setAttribute("data-source", source || "");
          box.setAttribute("data-resolved-url", url || "");
        } catch {}
      })
      .catch(() => {
        box.textContent = "No preview";
        box.style.fontSize = "11px"; box.style.opacity = "0.7";
      });
  }

  function mount() {
    document.querySelectorAll(".cart-sdl-box").forEach(mountOne);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", mount);
  } else {
    mount();
  }
})();
